import { I18n } from "localisation/i18n";
import TranslationPaths from "./TranslationPaths";

const strings = (name: TranslationPaths, params = {}) => I18n.t(name, params);

export default strings;
